module.exports = __webpack_public_path__ + "img/users-group-1.a746a924.svg";